import type { AdditionalFieldValues } from "@bbj-types/candidate";
import type { ObjectId, Override } from "@bbj-types/utils";
import type { DifficultyCoachingLevel } from "@inputs/DifficultyToggleGroup";
import { useCallback } from "react";
import { useAxiosInterviewExit } from "../../axios";
import type { IDynamicFormSchema, IInterviewExitCandidateChallenge, IInterviewExitCandidateFields } from "../types";

export interface IPutCandidateDraftInterviewExitBody {
  candidateFields?: Override<
    Pick<IInterviewExitCandidateFields, "coachingStep">,
    {
      coachingStep: IDynamicFormSchema;
    }
  >;
  candidateDynamicFields?: Record<string, AdditionalFieldValues | null>;
  challenges: IInterviewExitCandidateChallenge[];
  comment?: string;
  completed?: boolean;
  timeSpent?: number;
  contactChannel?: string;
  details?: string;
  difficulties?: Record<string, DifficultyCoachingLevel>;
}

export const usePutCandidateDraftInterviewExit = () => {
  const [state, execute, cancel] = useAxiosInterviewExit<void, IPutCandidateDraftInterviewExitBody>(
    {
      method: "PUT",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId, interviewExit: IPutCandidateDraftInterviewExitBody) =>
      execute({
        url: `/candidates/${candidateId}/interviews-exit/draft`,
        data: interviewExit,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
